module.exports = __webpack_public_path__ + "img/american.8d349d0a.png";